import type { PageHeaderFiFields } from '@/generated/fields';

type SlideElements = PageHeaderFiFields['slideElements'];
type SlideElementFields = SlideElements[number];

export default (slideElementFields: SlideElementFields) => ({
  headline: slideElementFields.headline?.value,
  subheadline: slideElementFields.subheadline?.value,
  url: slideElementFields.link?.value?.href,
  isButton: Boolean(slideElementFields.isButton?.value),
  buttonText: slideElementFields.buttonText?.value,
});
